import React, { useCallback, useEffect } from "react";
import { Dropdown, IDropdownOption } from "office-ui-fabric-react/lib/Dropdown";
import { IMessageBarStyles, MessageBar, MessageBarType } from "office-ui-fabric-react";
import { useField } from "formik";
import { wrapper } from "../../styles/formDropDown.styles";
import { useEffectAfterMount } from "../../hooks/useEffectAfterMount";

const errorMessageS: IMessageBarStyles = {
  root: {
    marginTop: "15px",
    width: "100%",
  },
};

export interface FormDropDownProps {
  name: string;
  headerText: string;
  options: Array<any>;
  placeholder?: string;
  onChange?: any
  onChangeEffect?: any,
  required?: boolean
  additionalInfo?: string
  defaultSelectedKey?: string,
  disabled?: boolean
}

const FormDropDown: React.FC<FormDropDownProps> = ({
  options,
  headerText,
  placeholder,
  name,
  onChange,
  onChangeEffect,
  required = true,
  additionalInfo = undefined,
  defaultSelectedKey,
  disabled
}) => {
  const [field, { value, error }, { setValue }] = useField(name);

  const handleChange = useCallback(
    async (event: React.FormEvent<HTMLDivElement> | null, option?: IDropdownOption) => {
      if (option) {

        setValue(option.key);
        if (onChange) {
          onChange(option)
        }
      }
    },
    [options]
  );

  useEffect(() => {
    if (!!defaultSelectedKey && !value && options.length === 1) {
      handleChange(null, options[0]);
    }
  }, [defaultSelectedKey, options, value]);

  useEffectAfterMount(() => {
    if (onChangeEffect) {
      if (options) {
        const item = options.find((option: any) => {
          if (option.key === value) {
            return option
          }
        })

        onChangeEffect(item)
      }
    }
  }, [value, options[0]])

  return (
    <div className={wrapper}>
      <Dropdown
        selectedKey={value || value === 0 ? value : ""}
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        label={headerText}
        disabled={disabled}
        required={required}
        defaultSelectedKey={defaultSelectedKey}
      />
      {additionalInfo != undefined ?
        <>{additionalInfo}</>
        : <></>}
      {error && (
        <MessageBar
          messageBarType={MessageBarType.error}
          isMultiline={false}
          dismissButtonAriaLabel="Close"
          styles={errorMessageS}
        >
          {error}
        </MessageBar>
      )}
    </div>
  );
};

export default FormDropDown;